import store from '@/store'

export default class {
  public static setHttpInterceptors: any = (axios: any) => {
    // set the Auth interceptor
    axios.interceptors.request.use(
      async (request: any) => {
        const token = store.state.identity.idToken
        if (token) {
          request.headers.Authorization = `Bearer ${token}`
        }
        return request
      },
      (error: any) => {
        return Promise.reject(error)
      })

    // set the Error interceptor
    axios.interceptors.response.use(
      (response: any) => response,
      (error: any) => {
        if (error.response.status === 404) {
          store.state.errorCode = 404
        }
        Promise.resolve(error)
      }
    )
  }
}
